import { render } from "./ModalCancel.vue?vue&type=template&id=657f2470"
import script from "./ModalCancel.vue?vue&type=script&lang=ts"
export * from "./ModalCancel.vue?vue&type=script&lang=ts"
script.render = render

export default script